import LanguageSwitcherMobile from "_shared/LanguageSwitcherMobile";
import loaderLogo from "assets/images/icons/logo.svg";
import { isSaudi } from "helpers/utils";
import { toGregorian } from "hijri-converter";
import moment from "moment";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setJWT,
  setRequestId, updateLoading
} from "redux/actions/commonActions";
import * as actions from "redux/actions/motorActions";
import lead_percentage_ico from "../../../../assets/images/lead/discount.svg";
import fulLogo from "../../../../assets/images/logos/Tawuniya-Logo.svg";
import { getCustomerDetails, getPromotionDetails, smsPromotion } from "../../services/index";
import StyleWrapper from "./style";
const TawuniyaLead = (props) => {
  const toast = useRef(null);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useSelector((state) => state.common.isLoading);
  const [cDetails, setCDetails] = useState(null);
  const [tmx, setTmx] = useState(null);
  const [tawuniyaLead, setTawiniyaLead] = useState(false);
  const [apiresp, setApiresp] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let Tawnparam = params.get("pmx");
    console.log(Tawnparam);

    if (Tawnparam) {
      if (!Tawnparam) {
        Tawnparam = window.location.search.slice(5);
      }
    }

    if (Tawnparam?.length>0) {
      setTmx(Tawnparam);
      dispatch(actions.setTmx(Tawnparam));
      dispatch(actions.tawuniyaLeadAction(true))
      dispatch(updateLoading(true));
      setTawiniyaLead(true);
    }

    dispatch(actions.LeadGeneratation(true));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        funnel_step: "step_0",
        step_name: "elm_lead_generation_view_item",
        page_source: "internal_click", // calculated based on using document.referrer
        items: [
          {
            item_name: "ELM Lead Generation",
            item_category: "Motor Insurance",
            item_class: "Individual",
          },
        ],
      },
    });
    getLeadDetails(Tawnparam);
  }, []);

  const handleLeadBtnClick = async () => {
    const reqData = {
      tmx,
      languageCode: i18n.resolvedLanguage === "ar" ? "A" : "E",
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        funnel_step: "step_1",
        step_name: "elm_lead_generation_select_item",
        TMX: tmx,
        items: [
          {
            item_name: "ELM Lead Generation",
            item_category: "Motor Insurance",
            item_class: "Individual",
          },
        ],
      },
    });
    try {
      dispatch(updateLoading(true));
      
      let res = cDetails
      if(tawuniyaLead){
        res =cDetails
      }else{
        res = await getPromotionDetails(reqData);
      }
      // res = await getPromotionDetails(reqData);
      let dateData = res.customerDetails?.dateOfBirth;
      let yob = moment(dateData).format("YYYY");
      const mob = moment(dateData).format("MM");

      // Hijri date Fix
      let convertedDate = null;
      if (res && isSaudi(res.customerDetails.idNumber)) {
        const birthDateList = res.customerDetails?.dateOfBirth.split("-");
        if (+birthDateList[0] < 1800) {
          convertedDate = toGregorian(+birthDateList[0], +birthDateList[1], +birthDateList[2]);
        }
      }
      //_________________

      if (res && res.customerDetails) {
        const getCustDtlsReq = {
          nationalId: res.customerDetails.idNumber,
          yob: convertedDate?.gy.toString() || yob.toString(),
          mob:
            convertedDate?.gm
              .toLocaleString("en-US", {
                minimumIntegerDigits: 2,
                useGrouping: false,
              })
              .toString() || mob.toString(),
        };
        const customerDetails = await getCustomerDetails(getCustDtlsReq, "elm");
        dispatch(
          actions.updateCustomerDetails({
            personalDetails: { ...getCustDtlsReq },
            customerDetails: customerDetails,
          })
        );
        dispatch(actions.setTmxVehicleDetails(res));
        if (tawuniyaLead === false) {
          dispatch(updateLoading(false));
          navigate("/lead/vehicle-details", { state: { lead: true, tmx: tmx } });
        } else {
          dispatch(updateLoading(false));
          navigate("/vehicle-details", { state: { lead: true, tmx: tmx } });
        }
      } else {
        dispatch(updateLoading(false));
        toast.current.show({
          severity: "error",
          summary: "Failed to get Promotion details",
          detail: res?.resultMessage,
          life: 7000,
        });
      }
    } catch (error) {
      dispatch(updateLoading(false));
      toast.current.show({
        severity: "error",
        summary: "Failure",
        detail: "Something went wrong. Try again!",
        life: 7000,
      });
    }
  };

  const getLeadDetails = (Tawnparam) => {
    
    if(Tawnparam?.length>0){
      const reqData = {
        tmx: tmx || Tawnparam,
        languageCode: i18n.resolvedLanguage === "ar" ? "A" : "E",
      };
      smsPromotion(reqData)
        .then((res) => {
          if (res.resultCode === "F") {
            dispatch(updateLoading(false));
           // navigate("/motor");
          } else {
            
            const Authtoken = res.authToken
            const Requestid = res.requestId
  
            dispatch(setJWT (Authtoken))
            dispatch(setRequestId(Requestid))
            setCDetails(res);
            setApiresp(true);
          }
        })
        .catch((e) => {
          dispatch(updateLoading(false));
          
         // navigate("/motor");
        })
        .finally(() => {});
    }else{
      
      const reqData = {
        tmx: tmx || Tawnparam,
        languageCode: i18n.resolvedLanguage === "ar" ? "A" : "E",
      };
      getPromotionDetails(reqData)
        .then((res) => {
          
          if (res.resultCode === "F") {
            dispatch(updateLoading(false));
           // navigate("/motor");
          } else {
            setCDetails(res);
            setApiresp(true);
            const Authtoken = res.authToken
            const Requestid = res.requestId
  
            dispatch(setJWT(Authtoken))
            dispatch(setRequestId(Requestid))
          }
        })
        .catch((e) => {
          dispatch(updateLoading(false));
          
         // navigate("/motor");
        })
        .finally(() => {});
    }
  
  };

  useEffect(() => {
    
    if (apiresp && tawuniyaLead && tmx) {
      
      handleLeadBtnClick();
    }
  }, [apiresp, tawuniyaLead, tmx]);

  return (
    <StyleWrapper className={i18n.language === "ar" ? "ar" : ""}>
      {loading && (
        <>
          <div className="loader-overlay">
            <img src={loaderLogo} alt="" />
          </div>
          <ProgressBar mode="indeterminate" color="#6B47F5" style={{ height: "6px" }}></ProgressBar>
        </>
      )}
      <div className="header">
        <img className="success-header-left-logo d-block" src={fulLogo} alt="logo" />
        <LanguageSwitcherMobile />
      </div>
      <div className="container">
        <div className="card_wrapper">
          <div className="card">
            <div className="card_content">
              <div className="lead_text order-last order-md-first">
                <h1>
                  {t("LEAD.HELLO")} {i18n.language === "ar" ? cDetails?.nameAr : cDetails?.nameEn} !
                </h1>
                <h4>
                  {/* <strong> {t("LEAD.Congratulations")}!</strong> */}
                  {t("LEAD.TEXT1")}
                </h4>
                {/* <p>{t("LEAD.TEXT2")}</p> */}
              </div>
              <div className="lead_image">
                <img
                  className="success-mid-image"
                  src={lead_percentage_ico}
                  alt="policySuccess"
                  width={290}
                  height={300}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <Button onClick={handleLeadBtnClick} className="act-btn">
          {t("LEAD.Button")}
        </Button>
      </div>
      <Toast ref={toast} />
    </StyleWrapper>
  );
};

export default TawuniyaLead;
